/**
 * Feed API Configuration
 * 
 * Centralized API endpoint configuration for feed module
 */

export const FEED_API_CONFIG = {
  BASE: '/feed',
  CATEGORIES: '/inspeksi/category-db',
  OPTIONS: '/inspeksi/options',
} as const;
